import React from 'react';

const DeleteProjects = ({
  modalInfo,
  handleCloseModal,
  handleDeleteProjects
}) => {
  return (
    <div className="delete-modal-content">
      <p>Delete the selected Launchplans?</p>
      <div className="delete-modal-buttons">
        <button
          className="btn btn--secondary-outline delete-modal-button"
          onClick={() => handleDeleteProjects(modalInfo)}
        >
          Delete
        </button>
        <button
          className="btn btn--primary-outline delete-modal-button"
          onClick={handleCloseModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteProjects;
